import { apiSlice } from '../../store/apiSlice';

export const articlesApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getArticles: builder.query({
      query: () => ({
        url: 'social',
        method: 'get',
        useDefaultErrorHandler: false,
      }),
    }),
  }),
});

export const { useGetArticlesQuery } = articlesApiSlice;
